export default {
  methods: {
    resetObject (data) {
      for (const prop in data) {
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty(prop)) {
          if (typeof data[prop] === 'boolean') {
            data[prop] = false
          } else if (typeof data[prop] === 'number') {
            data[prop] = null
          } else if (typeof data[prop] === 'object' && !Array.isArray(data[prop])) {
            this.resetObject(data[prop])
          } else if (typeof data[prop] === 'object' && Array.isArray(data[prop])) {
            data[prop] = []
          } else {
            data[prop] = ''
          }
        }
      }
    }
  }
}
